'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = require('./lib/api');

var _api2 = _interopRequireDefault(_api);

var _renderer = require('./renderer');

var _renderer2 = _interopRequireDefault(_renderer);

var _controller = require('./controller');

var _controller2 = _interopRequireDefault(_controller);

var _defaults = require('./defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _validation = require('./validation');

var validationRules = _interopRequireWildcard(_validation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable import/first */
/* global VERSION */
require('./polyfills/array.from');

var merge = require('lodash/merge');

var Icarus = function () {
    /* eslint-disable object-curly-newline */
    function Icarus(container, _ref) {
        var formId = _ref.formId,
            apollo = _ref.apollo,
            apiRoot = _ref.apiRoot,
            themesLocation = _ref.themesLocation,
            theme = _ref.theme,
            validation = _ref.validation,
            listeners = _ref.listeners;

        _classCallCheck(this, Icarus);

        /* eslint-enable object-curly-newline */
        this.container = container;

        this._formId = formId;
        this._apollo = apollo;
        this._apiRoot = apiRoot;
        this._themesLocation = themesLocation;
        this._theme = theme;
        this._validation = validation;
        this._listeners = listeners;

        this._form = null;
        this._errors = {};

        var apiArgs = { apollo: this.apollo, apiRoot: this.apiRoot };
        this._api = new _api2.default(apiArgs);
        this._controller = new _controller2.default();
        this._renderer = null;

        this.initialize();
    }

    //-- Getters / Setters --//


    _createClass(Icarus, [{
        key: 'initialize',
        value: function initialize() {
            this.registerControllerActions();

            this.getFormData();

            this.loadTheme();
        }
    }, {
        key: 'registerControllerActions',
        value: function registerControllerActions() {
            // FORM RETRIEVED
            this.controller.addListener('icarus:form:retrieved', this.onFormRetrieved.bind(this));

            // FORM RENDERED
            this.controller.addListener('icarus:form:rendered', this.listeners.onRendered.bind(this));

            // FIELD CHANGED
            this.controller.addListener('icarus:field:changed', this.onFieldChanged.bind(this));

            // FIELD VALIDATION REQUESTED
            this.controller.addListener('icarus:field:validation_requested', this.validateField.bind(this));

            // FORM SUBMITTED
            this.controller.addListener('icarus:form:submitted', this.validateFields.bind(this));

            // FORM VALIDATED
            this.controller.addListener('icarus:form:validated', this.submitFormData.bind(this));

            // FORM SAVED
            this.controller.addListener('icarus:form:saved', this.onSubmissionResponse.bind(this));

            // FORM ERROR
            this.controller.addListener('icarus:form:error', this.listeners.onFailure.bind(this));
        }
    }, {
        key: 'getFormData',
        value: function getFormData() {
            var _this = this;

            this.api.forms.get(this.formId, function (resp) {
                return _this.controller.trigger('icarus:form:retrieved', resp);
            });
        }
    }, {
        key: 'loadTheme',
        value: function loadTheme() {
            var link = document.createElement('link');

            link.href = this.themesLocation + '/' + this.theme + '/index.css';
            link.rel = 'stylesheet';

            var head = document.getElementsByTagName('head')[0];

            // insert the theme as high as possible to offer the greatest flexibility in overriding
            head.insertBefore(link, head.firstChild);
        }

        //-- Listener Actions --//

    }, {
        key: 'onFormRetrieved',
        value: function onFormRetrieved(form) {
            this.form = form;

            var _form = this.form,
                name = _form.name,
                fields = _form.fields,
                submit_button_text = _form.submit_button_text;


            this.renderer = new _renderer2.default(this.container, {
                formName: name,
                formFields: fields,
                formSubmitButton: submit_button_text,
                controller: this.controller
            });

            this.renderer.render();
        }
    }, {
        key: 'onFieldChanged',
        value: function onFieldChanged(icField, newValue) {
            if (this._errors[icField.id]) {
                delete this._errors[icField.id];
                this.controller.trigger('icarus:field:validation_fixed', icField, { validationStatus: null });
            }

            if (this.validation.trigger === 'change') {
                this.controller.trigger('icarus:field:validation_requested', icField, newValue);
            }
        }

        /**
         * validate the given list of fields
         * @param icFields @{Array} of @{Object} form fields with input data
         */

    }, {
        key: 'validateFields',
        value: function validateFields(icFields) {
            var anyErrors = icFields.map(this.validateField.bind(this)).some(function (passed) {
                return !passed;
            });

            // if there were no errors, then trigger a validation event
            if (!anyErrors) {
                this.controller.trigger('icarus:form:validated', icFields);
            }
        }

        /**
         * perform validation on the given field
         * @param icField
         */

    }, {
        key: 'validateField',
        value: function validateField(icField) {
            var value = icField.value;


            var isValid = void 0;
            var errorMsg = void 0;

            switch (icField.validation_rule) {
                case 'OPTIONAL':
                    isValid = validationRules.isOptional(value);
                    break;
                case 'REQUIRED':
                    var _ref2 = [validationRules.isRequired(value), 'a value is required'];
                    isValid = _ref2[0];
                    errorMsg = _ref2[1];

                    break;
                case 'EMAIL':
                    var _ref3 = [validationRules.isEmail(value), (value || '') + ' is not a valid email'];
                    isValid = _ref3[0];
                    errorMsg = _ref3[1];

                    break;
                case 'PHONE_NUMBER':
                    var _ref4 = [validationRules.isPhoneNumber(value), (value || '') + ' is not a valid phone number'];
                    isValid = _ref4[0];
                    errorMsg = _ref4[1];

                    break;
                default:
                    console.warn(icField.validation_rule + ' isn\'t a recognized validation rule');
                    isValid = true;
            }

            if (!isValid) {
                this._errors[icField.id] = errorMsg;
                this.controller.trigger('icarus:field:validation_error', icField, { validationStatus: 'error', validationError: errorMsg });
            } else {
                this.controller.trigger('icarus:field:validation_success', icField, { validationStatus: 'validated' });
            }

            return isValid;
        }
    }, {
        key: 'submitFormData',
        value: function submitFormData(formData) {
            var _this2 = this;

            var submissionData = { form: this.formId, raw_data: formData };

            var shouldSubmit = this.listeners.onSubmit(formData);
            if (!shouldSubmit) {
                this.controller.trigger('icarus:form:error', 'unknown error submitting form');
                return;
            }

            this.api.submissions.create(submissionData, function (resp) {
                _this2.controller.trigger('icarus:form:saved', {
                    redirectUrl: _this2.form.redirect_url,
                    successMessage: _this2.form.success_message
                });
            });
        }
    }, {
        key: 'onSubmissionResponse',
        value: function onSubmissionResponse(_ref5) {
            var redirectUrl = _ref5.redirectUrl,
                successMessage = _ref5.successMessage;

            this.listeners.onSuccess({ redirectUrl: redirectUrl, successMessage: successMessage });

            if (redirectUrl) {
                Icarus.setWindowLocation(redirectUrl);
            }
        }

        //-- Helpers --//
        // we do this for ease of stubbing in our tests

    }, {
        key: 'formId',
        get: function get() {
            return this._formId || _defaults2.default.formId;
        }
    }, {
        key: 'apollo',
        get: function get() {
            return this._apollo || _defaults2.default.apollo;
        }
    }, {
        key: 'apiRoot',
        get: function get() {
            return this._apiRoot || _defaults2.default.apiRoot;
        }
    }, {
        key: 'themesLocation',
        get: function get() {
            return this._themesLocation || _defaults2.default.themesLocation;
        }
    }, {
        key: 'theme',
        get: function get() {
            return this._theme || _defaults2.default.theme;
        }
    }, {
        key: 'validation',
        get: function get() {
            return this._validation || _defaults2.default.validation;
        }
    }, {
        key: 'listeners',
        get: function get() {
            return merge({}, _defaults2.default.listeners, this._listeners);
        }
    }, {
        key: 'form',
        get: function get() {
            return this._form;
        },
        set: function set(form) {
            this._form = form;
        }
    }, {
        key: 'api',
        get: function get() {
            return this._api;
        }
    }, {
        key: 'controller',
        get: function get() {
            return this._controller;
        }
    }, {
        key: 'renderer',
        get: function get() {
            return this._renderer;
        },
        set: function set(renderer) {
            this._renderer = renderer;
        }

        /**
         * set global defaults applicable to every Icarus instance
         * @param newDefaults
         */

    }], [{
        key: 'setDefaults',
        value: function setDefaults(newDefaults) {
            Object.keys(newDefaults).forEach(function (k) {
                _defaults2.default[k] = newDefaults[k];
            });
        }
    }, {
        key: 'setWindowLocation',
        value: function setWindowLocation(url) {
            window.location = url;
        }
    }]);

    return Icarus;
}();

if (process.env.BUILD_FOR_WINDOW) {
    window.Icarus = Icarus;
}

exports.default = Icarus;


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/icarus.js
// module id = 192
// module chunks = 2 3